import React, { useEffect, useState } from 'react'
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput'
import styles from "./styles.module.scss";
import { inputStyle, poItemListingColumns } from './constant';
import { regex } from 'views/pages/manage/common/constant/regex/index';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import PoSerialItemListing from './PoSerialItemListing';
import { CheckBox } from 'views/pages/manage/unAssigned/collectPayment/selectCharges/components/Checkbox';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
const ListEditableComponent = ({ rows, serialItemList, setSerialItemList, rowFormHandler, grnType }) => {
    const [isOpen, setOpen] = useState(false);

    return rows?.map((item, index) => (
        <>
            <div className={`${styles["table-list"]} mt-3 mx-3`} key={`${index}-${item?.MATERIAL}`}>
                {poItemListingColumns.map((col) => {
                    switch (col?.type) {
                        case "input":
                            return <AInput
                                key={`${index}-${col?.colKey}`}
                                type="text"
                                value={item[col?.colKey] || ""}
                                handler={(value) => {
                                    const numericVal = parseFloat(value) || 0;
                                    if (col?.colKey === 'quantity') {
                                        if (value === "" || (!isNaN(numericVal) && numericVal <= item.maxQuantity)) {
                                            rowFormHandler(index, col?.colKey, numericVal);
                                            const slicedSerialItems = item?.serialItem?.slice(0, numericVal);
                                            rowFormHandler(index, "updatedSerialItems", slicedSerialItems);
                                        }
                                    } else {
                                        rowFormHandler(index, col?.colKey, value);
                                    }
                                }}
                                disabled={col.disabled || (col?.colKey === "quantity" &&
                                    (grnType?.value === "pendingScreen" || grnType?.value === "102"))
                                }
                                placeholder="Enter"
                                style={inputStyle}
                                regex={col?.colKey === 'quantity' ? regex?.numericDecimal : null}
                            />
                        case "select":
                            return <AAutoComplete
                                key={`${index}-${col?.colKey}`}
                                placeholder="Select"
                                currentValue={item[col?.colKey]}
                                handleChange={(value) => { rowFormHandler(index, col?.colKey, value) }}
                                items={[{ label: '101', value: '101' },
                                { label: '102', value: '102' }
                                ]}
                                isMulti={false}
                                isShowCount={false}
                                style={{ control: inputStyle }}
                                isInputChange={true}
                                isDisabled={col.disabled}
                            />
                        case "checkbox":
                            if (grnType?.value !== "101") return null;
                            return (
                                <CheckBox
                                    key={`${index}-${col?.colKey}`}
                                    handler={(checked) => rowFormHandler(index, col?.colKey, checked)}
                                    isChecked={item[col?.colKey] || false}
                                    disabled={col?.disabled}
                                />
                            );
                            return <></>
                        // Warning
                        default:
                            return (item.serialItem?.length > 0) ? (
                                <AButton
                                    key={`${index}-${col?.colKey}`}
                                    variant="link"
                                    className="no-ml-btn"
                                    onClick={() => {
                                        setSerialItemList(item.serialItem?.slice(0, item?.quantity));
                                        setOpen(true);
                                    }}
                                    size="xs"
                                >
                                    View
                                </AButton>
                            ) : null;
                    }

                })}

            </div>
            <PoSerialItemListing open={isOpen} setOpen={setOpen} title='Serial Item Listing' rows={serialItemList} listingKey={'serialNo'} />
        </>

    ))

}
export default ListEditableComponent